<template>
    <div class="services">
        <Title :title="'Serviços'"></Title>
        <div class="row center-xs service-line">
            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-6">
                <div class="row" v-if="services">
                    <div class="col-xs-12 col-sm-4 col-md-6 col-lg-4 mobile-padded__evenly" v-for="service in services.items" :key="service.fields.title">
                        <ServiceCard v-on:card-selection="onSelectService(service)" :service="service"></ServiceCard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ServiceCard from "../cards/ServiceCard";
    import Title from "../generic/Title";

    export default {
        name: "Services",
        components: {ServiceCard, Title},
        props: ['services'],
        methods: {
            onSelectService(service) {
                this.$router.push(`/service/${service.sys.id}`).catch(() => {});
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/global";

    .services {
        //margin-top: 3em;
        margin-bottom: 3em;
        height: 100%;
    }

    .service-line {
        margin-top: 3em;
    }
</style>
